import React from 'react';
import { CorrectButton, FooterContainer, StartButton, TryLaterButton } from '../atoms/styles';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import { Tooltip } from '@material-ui/core';
import useKeyPress from '../../hooks/useKeyPress';
import { useAppDispatch } from 'src/modules/shared/hooks/useAppDispatch';
import {
  SidePanelModes,
  changePanelContent,
  openSidePanel,
} from 'src/modules/shared/slices/sidePanel/sidePanelSlice';

type FooterProps = {
  trainingStarted?: boolean;
  onFlipCard: () => void;
  onAcceptAnswer: (isCorrect: boolean) => void;
  flipCard?: boolean;
};

const StudyCardFooter: React.FC<FooterProps> = ({
  trainingStarted,
  onFlipCard,
  flipCard,
  onAcceptAnswer,
}) => {
  const handleFlipCard = () => {
    if (flipCard) return;
    return onFlipCard();
  };
  const handleTryLater = () => {
    if (!flipCard) return;
    return onAcceptAnswer(false);
  };
  const handleAcceptAnswer = () => {
    if (!flipCard) return;
    return onAcceptAnswer(true);
  };
  useKeyPress('ArrowRight', handleFlipCard);
  useKeyPress('ArrowUp', handleAcceptAnswer);
  useKeyPress('ArrowDown', handleTryLater);

  const dispatch = useAppDispatch();
  return (
    <FooterContainer>
      {trainingStarted ? null : (
        <StartButton
          variant="primary"
          onClick={() => {
            dispatch(changePanelContent(SidePanelModes.TRAINER_FORM));
            dispatch(openSidePanel(true));
          }}
        >
          trainen
        </StartButton>
      )}
      {trainingStarted ? (
        <>
          {!flipCard ? (
            <Tooltip
              placement="top"
              title={`TIP: dit kan ook met een klik op ▶️ op je toetsenbord`}
            >
              <span>
                <StartButton variant="primary" onClick={onFlipCard}>
                  omdraaien
                </StartButton>
              </span>
            </Tooltip>
          ) : (
            <span style={{ display: 'flex', gap: '1rem' }}>
              <Tooltip
                placement="top"
                title="TIP: dit kan ook met een klik op 🔽 op je toetsenbord."
              >
                <span>
                  <TryLaterButton
                    startIcon={
                      <FontAwesomeSpriteIcon icon={SpriteIconsSolid.SYNC_ALT} color="white" />
                    }
                    onClick={() => onAcceptAnswer(false)}
                  >
                    LATER OPNIEUW
                  </TryLaterButton>
                </span>
              </Tooltip>
              <Tooltip
                placement="top"
                title="TIP: dit kan ook met een klik op 🔼 op je toetsenbord."
              >
                <span>
                  <CorrectButton
                    startIcon={
                      <FontAwesomeSpriteIcon icon={SpriteIconsSolid.CHECK} color="white" />
                    }
                    onClick={() => onAcceptAnswer(true)}
                  >
                    HAD IK JUIST
                  </CorrectButton>
                </span>
              </Tooltip>
            </span>
          )}
        </>
      ) : null}
    </FooterContainer>
  );
};

export default StudyCardFooter;
